export const modularLibrarySceneItemCopy = {
  en: {
    keyboardHint: 'Use Up or Down to choose a book or collectible, then Enter or Space to preview.',
  },
  sk: {
    keyboardHint:
      'Šípkou nahor alebo nadol vyberte knihu či predmet. Náhľad otvoríte klávesom Enter alebo medzerníkom.',
  },
  cs: {
    keyboardHint:
      'Šipkou nahoru nebo dolů vyberte knihu či předmět. Náhled otevřete klávesou Enter nebo mezerníkem.',
  },
} as const;
